import { createSlice } from '@reduxjs/toolkit';
import { camelCase } from 'lodash-es';
import { Status } from '.';
import { createAsyncAction } from '../action';

const getAllZones = createAsyncAction('getAllZones', 'getAllZones');
const getAllCity = createAsyncAction('getAllCity', 'getAllCity');
const getCityByZone = createAsyncAction('getCityByZone', 'getCityByZone');
const addNewZone = createAsyncAction('addNewZone', 'addNewZone');
const addNewCity = createAsyncAction('addNewCity', 'addNewCity');

interface IInitialState {
  isFetchingZones: boolean;
  isFetchingAllCity: boolean;
  isFetchingCityByZone: boolean;
  addingZoneStatus: string;
  addingCityStatus: string;
  zones: any;
  zoneByName: any;
  cities: any;
  cityNamesByZone: any;
  citiesByZone: any;
  cityByZoneCity: any;
  newZone: any;
  newCity: any;
}

const initialState = {
  isFetchingZones: false,
  isFetchingAllCity: false,
  isFetchingCityByZone: false,
  addingZoneStatus: '',
  addingCityStatus: '',
  zones: [],
  zoneByName: {},
  cities: [],
  cityNamesByZone: {},
  citiesByZone: {},
  cityByZoneCity: {},
  newZone: {},
  newCity: {},
} as IInitialState;

export const counterSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateAppState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getAllZones.pending as any]: (state) => {
      state.isFetchingZones = true;
    },
    [getAllZones.fulfilled as any]: (state, { payload }) => {
      state.isFetchingZones = false;
      state.zoneByName = {};
      const zones: any = [];
      const sortedList = (payload?.data || []).sort((a, b) => a.name < b.name ? -1 : 1);
      sortedList.forEach(zone => {
        const zoneName = camelCase(zone.name);
        if (!state.zoneByName[zoneName]) {
          zones.push(zone);
          state.zoneByName[zoneName] = zone;
        }
      });
      state.zones = zones;
    },
    [getAllZones.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingZones = false;
      }
    },

    [getAllCity.pending as any]: (state) => {
      state.isFetchingAllCity = true;
    },
    [getAllCity.fulfilled as any]: (state, { payload }) => {
      state.isFetchingAllCity = false;
      state.cityByZoneCity = {};
      state.citiesByZone = {};
      state.cityNamesByZone = {};
      const cities: any = [];
      const sortedList = (payload?.data || []).sort((a, b) => a.name < b.name ? -1 : 1);
      sortedList.forEach(city => {
        const cityName = city.name;
        const zone = camelCase(city.state.name);
        const zoneCityKey = `${zone}:${cityName}`;

        if (!state.cityByZoneCity[zoneCityKey]) {
          cities.push(city);
          state.cityByZoneCity[zoneCityKey] = city;

          if (state.cityNamesByZone[zone]) {
            state.citiesByZone[zone].push(city);
            state.cityNamesByZone[zone].push(cityName);
          } else {
            state.citiesByZone[zone] = [city];
            state.cityNamesByZone[zone] = [cityName];
          }
        }
      });
      state.cities = cities;
    },
    [getAllCity.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingAllCity = false;
      }
    },

    [getCityByZone.pending as any]: (state) => {
      state.isFetchingCityByZone = true;
    },
    [getCityByZone.fulfilled as any]: (state, { meta, payload }) => {
      const zone = camelCase(meta.arg.zone);
      state.isFetchingCityByZone = false;
      state.citiesByZone[zone] = payload.data || [];
      state.cityNamesByZone[zone] = (payload.data || []).map(city => city.name);
    },
    [getCityByZone.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingCityByZone = false;
      }
    },

    [addNewZone.pending as any]: (state) => {
      state.addingZoneStatus = Status.pending;
    },
    [addNewZone.fulfilled as any]: (state, { payload }) => {
      state.addingZoneStatus = Status.fulfilled;
      state.newZone = payload?.data || {};
    },
    [addNewZone.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.addingZoneStatus = Status.rejected;
      }
    },

    [addNewCity.pending as any]: (state) => {
      state.addingCityStatus = Status.pending;
    },
    [addNewCity.fulfilled as any]: (state, { payload }) => {
      state.addingCityStatus = Status.fulfilled;
      state.newCity = payload?.data || {};
    },
    [addNewCity.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.addingCityStatus = Status.rejected;
      }
    },
  },
});

const { updateAppState } = counterSlice.actions;
export {
  updateAppState,
  getAllZones,
  getAllCity,
  getCityByZone,
  addNewZone,
  addNewCity,
};
export default counterSlice.reducer;
